import { render, staticRenderFns } from "./Backdrop.vue?vue&type=template&id=48f876d4"
import script from "./Backdrop.vue?vue&type=script&lang=js"
export * from "./Backdrop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports